module.exports = __webpack_public_path__ + "static/waltz_kore_za_tortu_2-071085c95fbcf622efcf3763988c3e48.jpg";